<template>
  <b-card title="ผลการค้นหา">
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <!-- <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group> -->
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      @on-page-change="onPageChange"
      @on-per-page-change="onPageLengthChange"
      :totalRows="totalRecords"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: No -->
        <!-- <span v-if="props.column.field === 'No'" class="text-nowrap" >
          <span class="text-nowrap">  1 </span>
        </span> -->

        <span v-if="props.column.field === 'docCode'" class="text-nowrap">
          <span class="text-nowrap"
            >{{ props.row.docCode }}
            <br />
            {{ props.row.complaintCode }}
            <br />
            {{ props.row.createApproveStr }}
          </span>
        </span>

        <span v-if="props.column.field === 'status'" class="text-nowrap">
          <!-- <span class="text-nowrap"
            >{{ props.row.statusdescription }} / {{ props.row.approverFName }}
            {{ props.row.approverLName }}</span
          > -->
          <span class="text-nowrap"
            >สถานะ: {{ props.row.statusdescription }} </span
          ><br />
          <span class="text-nowrap"
            >ผู้อนุมัติ: {{ props.row.approverFName }} {{ props.row.approverLName }}</span
          >
        </span>

        <span v-if="props.column.field === 'file'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.description }}</span>
        </span>
        <span v-if="props.column.field === 'Complain_Date'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.dateStr }}</span>
        </span>
        <span v-if="props.column.field === 'name'" class="text-nowrap">
          <span class="text-nowrap"
            >ผู้สร้างเอกสาร: {{ props.row.fName }} {{ props.row.lName }}</span
          ><br />
          <span class="text-nowrap"
            >หน่วยงาน: {{ props.row.departmentName }}</span
          >
        </span>
        <span
          v-if="props.column.field === 'statusSecretaryVerification'"
          class="text-nowrap"
        >
          <span v-if="props.row.statusSecretaryVerification === 540"
            ><span class="text-nowrap"> สถานะ: ตรวจสอบเอกสารแล้ว </span><br />
            <span class="text-nowrap"
              >ผู้ตรวจสอบ: {{ props.row.secretaryName }}</span
            >
          </span>
          <span v-else>
            <span class="text-nowrap">สถานะ: -</span><br />
            <span class="text-nowrap">ผู้ตรวจสอบ: -</span>
          </span>
        </span>
        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <b-button variant="primary" @click="getSuccess(props.row.docId)">
            ดูเอกสารคำขอ
          </b-button>
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import { VueGoodTable } from "vue-good-table";
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";
import { codeBasic } from "@/views/table/vue-good-table/code";
import store from "@/store/index";
import Ripple from "vue-ripple-directive";
import * as viewStore from "@/store/api/approve/approve.js";
import TableHeaders from "./commonTableHeader.js";
import appsettings from "@/store/app-settings";
import * as documentStore from "@/store/api/document/index.js";
import * as userData from "@/auth/localStorageUtils.js";

export default {
  directives: {
    Ripple,
  },
  components: {
    BCardCode,
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
    viewStore,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    return {
      tabMode: props.mode,
    };
  },
  data() {
    return {
      pageLength: 10,
      totalRecords: 0,
      dir: false,
      codeBasic,
      columns: TableHeaders,
      rows: [],
      searchTerm: "",
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
      params: {},
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  methods: {
    onPageChange(page) {
      console.log("onPageChanged", page);
      this.onSearchSubmit(this.params, page);
    },
    onPageLengthChange(pageLength) {
      console.log("onPageLengthChanged", pageLength);
      this.onSearchSubmit(this.params, 1);
    },
    onSearchSubmit(params, page = { currentPage: 1 }) {
      //console.log('onSearchSubmit', params)

      var _this = this;

      this.params = params;

      params.page = page.currentPage;
      params.perPage = this.pageLength;

      let redirectUrl =
        location.origin + this.$router.resolve({ name: "Approve" }).href;

      //params.userId = userData.userId();
      //params.authen = userData.userId();
      // params.userId = "3D2E1324-A160-493A-8BA8-B9C8039607CC";
      // params.authen = "3D2E1324-A160-493A-8BA8-B9C8039607CC";
      params.redirectUrl = redirectUrl;
      params.redirectBack = redirectUrl;

      _this.$emit("handleOverlay", true);

      if (_this.tabMode === "List") {
        console.log("tabMode List");
        viewStore
          .getDocumentForUserApprove(params)
          .then(function(response) {
            _this.rows = response.data.data;

            try {
              _this.totalRecords = response.data.data[0].totalCount;
            } catch (ex) {
              console.log("get total records error", ex);
              _this.totalRecords = 0;
            }
          })
          .catch(function(error) {
            console.log("error", error);
            _this.totalRecords = 0;
          });
      } else {
        console.log("tabMode History");
        viewStore
          .getDocumentForUserApprove(params)
          .then(function(response) {
            _this.rows = response.data.data;
          })
          .catch(function(error) {
            console.log("error", error);
          });
      }
    },
    getSuccess(docId) {
      let redirectUrl =
        location.origin + this.$router.resolve({ name: "Approve" }).href;
      let redirectBack =
        location.origin + this.$router.resolve({ name: "Approve" }).href;

      let documentUrl = appsettings.documentUrlApprove
        .replace("{0}", docId)
        .replace("{1}", userData.userId())
        .replace("{2}", redirectUrl)
        .replace("{3}", redirectBack);

      //window.location.href = documentUrl;

      if (userData.isSecretary()) {
        documentUrl += "&isSecretary=1";
      }

      window.open(documentUrl, "_blank");
    },
    onDocumentUrlClicked(documentUrl) {
      window.open(documentUrl, "_blank");
    },
  },
};
</script>
